// extracted by mini-css-extract-plugin
module.exports = {"container":"StageOptionList_container__vBJs_","stageWrapper":"StageOptionList_stageWrapper__qKAho","stageLabel":"StageOptionList_stageLabel__3hA9Q"};